<template>
  <Card>
    <div class="action_bar">
      <Input v-model="queryInfo.pname" placeholder="请输入项目名称" clearable class="searchBar" />
      <Select clearable v-model="queryInfo.type" placeholder="请选择项目类型" class="searchBar">
        <Option v-for="item in typeOptions" :value="item.name" :key="item.name">{{ item.value }}</Option>
      </Select>
      <Select clearable v-model="queryInfo.mode" placeholder="请选择采购方式" class="searchBar">
        <Option v-for="item in modeOption" :value="item.name" :key="item.name">{{ item.value }}</Option>
      </Select>
      <DatePicker v-if="showDate" class="searchBar" :editable="false" clearable placement="bottom-end" type="daterange" format="yyyy-MM-dd" split-panels v-model="daterange" @on-change="arr => {queryInfo.sdt = arr[0],queryInfo.edt = arr[1]}" placeholder="请选择近期时间范围"></DatePicker>
      <Button type="primary" icon="ios-search" @click="getData">搜索</Button>
    </div>
    <Table :columns="columns" :data="data" :loading="loading" border>
      <template slot-scope="{ row, index }" slot="file">
        <span v-if="row.projectFileVoList.length" class="file_btn" @click="openModal(row)">查看</span>
      </template>
      <template slot-scope="{ row, index }" slot="status">
        <Tag v-if="showDate" :color="row.isRegistration==='已报名'?'green':'blue'">{{row.isRegistration}}</Tag>
        <Tag v-else :color="row.isTender==='已投标'?'green':'blue'">{{row.isTender}}</Tag>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button :disabled="row.isRegistration==='已报名'||row.isTender==='已投标'||row.deadline==='已开标'" class="action_btn" type="text"  @click="partIn(row)">我要参与</Button>
      </template>
    </Table>
    <Page 
    :total="total" 
    show-total 
    show-elevator 
    show-sizer 
    :page-size-opts="[10,20,50]" 
    @on-change="pageNumChange"
    @on-page-size-change="pageSizeChange"/>
    <Modal
      v-model="modal"
      title="查看文件"
      @on-ok="modal = false"
      @on-cancel="modal = false">
      <CellGroup>
        <Cell v-for="(i,index) in currentList" class="file_cell">
          <div>
            <span style="margin-right:10px">{{index+1}}.</span>
            <span style="margin-right:10px">{{i.fname}}</span>
            <Icon @click="viewFile(i,0)" size="18" color="#1890FF" type="md-eye" style="margin-right:10px" />
            <Icon @click="viewFile(i,1)" size="18" color="#1890FF" type="md-cloud-download" /></div>
        </Cell>
      </CellGroup>
    </Modal>
  </Card>
</template>
<script>
import { getModeList,getTypeList,getProjectInfo,getMyProjectPage,getFileUrl,addProjectFileReader} from '@/api/api'
export default {
  data() {
    return {
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        pname: '',
        mode: '',
        type: '',
        edt: '',
        sdt: '',
      },
      data: [],
      columns: [
        {
          width: '80',
          type: 'index',
          title: '序号',
          fixed:'left'
        },
        {
          title: '项目名称',
          key: 'pname',
          minWidth: 200,
          ellipsis:true,
          tooltip:true,
          fixed:'left'
        },
        {
          title: '招标文件发售日期',
          key: 'biddingTime',
          width: 200,
          ellipsis:true,
          tooltip:true,
          align: 'center'
        },
        {
          title: '招标文件发售截止时间倒计时',
          key: 'deadline',
          width: 220,
          align: 'center'
        },
        {
          title: '采购类型',
          key: 'type',
          width: 100
        },
        {
          title: '文件',
          slot: 'file',
          width: 100,
          align: 'center'
        },
        {
          title: '状态',
          slot: 'status',
          width: 100,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ],
      typeOptions: [],
      modeOption: [],
      daterange: [],
      loading: false,
      total: 0,
      showDate: false,
      modal: false,
      currentList:[]
    }
  },
  watch: {
    '$route.name':{
      handler (val) {
        this.queryInfo.pageNum = 1
        this.queryInfo.pageSize = 10
        if(val === 'projectInfo'){
          this.showDate = true
          this.queryInfo.sdt = ''
          this.queryInfo.edt = ''
        }else {
          this.showDate = false
        }
        this.getData()
      },
      immediate: true
    }

  },
  created () {
    getTypeList().then(res => { this.typeOptions = res })
    getModeList().then(res => { this.modeOption = res })
  },
  methods: {
    partIn (row) {
      this.$router.push({
        path: this.showDate?'apply':'tender',
        query: { id: row.id }
      })
    },
    getData () {
      this.loading = true
      if(this.showDate){
        getProjectInfo(this.queryInfo).then(res => {
          this.data = res.list
          this.total = res.total
          this.loading = false
        }).catch(err => this.loading = false)
      }else {
        getMyProjectPage(this.queryInfo).then(res => {
          this.data = res.list
          this.total = res.total
          this.loading = false
        }).catch(err => console.log(err))
      }
    },
    pageNumChange(val){
      this.queryInfo.pageNum = val
      this.getData()
    },
    pageSizeChange(val){
      this.queryInfo.pageSize = val
      this.queryInfo.pageNum = 1
      this.getData()
    },
    openModal(row){
      addProjectFileReader(row.id)
      this.currentList = row.projectFileVoList
      this.modal = true
    },
    viewFile(row,type){
      // 0 预览 1 下载
      getFileUrl(row.fid).then(res => {
        if(!type){
          var ele = document.createElement('a')
          ele.style.display = 'none'
          ele.href = res.data
          ele.target = "_blank"
          document.body.appendChild(ele)
          ele.click()
          document.body.removeChild(ele)
        }else {
          let x = new XMLHttpRequest();
          let that = this
          x.open("GET", res.data, true);
          x.responseType = 'blob';
          x.onload=function(e) {
            let url = window.URL.createObjectURL(x.response)
            let a = document.createElement('a');
            a.href = url
            a.download = row.fname;
            that.loading = false
            a.click()
          }
          x.send()
        }
      }).catch(err => console.log(err))
    }
  }
}
</script>
<style lang='scss' scoped>
  .ivu-card {
    height: calc(100vh - 135px);
  }
  .action_bar{
    display: flex;
    margin: 8px 0 24px 0;
    .searchBar {
      max-width: 300px;
      margin-right: 20px;
    }
  }
  .ivu-page {
    text-align: center;
    margin: 40px;
  }
  ::v-deep .action_btn {
    font-size: 14px;
    color: #1890FF
  }
  ::v-deep .file_btn {
    font-size: 14px;
    color: #1890FF;
  }
  ::v-deep .file_btn:hover {
    cursor: pointer;
    text-decoration:underline;
  }
</style>